$(document).on('turbo:load', function () {
  $('.js-mask-date').mask('00/00/0000');
  $('.js-time').mask("00:00");
  $('.js-meridian').mask("PM");
  $('.js-times').mask('000');
  $('.js-mask-phone').mask('(000) 000-0000');
});
